import { Inject, Injectable } from '@angular/core';
import { CrudService } from 'src/app/core/services/crud.service';
import { IPuntoCampionamentoTipologia } from './punti-campionamento-tipologie.model';
import { PUNTICAMPIONAMENTOTIPOLOGIE_ENDPOINT, PUNTICAMPIONAMENTOTIPOLOGIE_QUERY_SERVICE_INSTANCE } from './punti-campionamento-tipologie.config';
import { QueryService } from 'src/app/core/services/query.service';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class PuntiCampionamentoTipologieService extends CrudService<IPuntoCampionamentoTipologia> {

  constructor(
    @Inject(PUNTICAMPIONAMENTOTIPOLOGIE_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<IPuntoCampionamentoTipologia>,
    @Inject(ApiService) protected override readonly api: ApiService,
    @Inject(SnackbarService) protected override readonly snackbar: SnackbarService
  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(PUNTICAMPIONAMENTOTIPOLOGIE_ENDPOINT, api, snackbar);
  }

}
